import { defineStore } from 'pinia';
import api from '@/services/api';
import { getParamsUrl } from './suaje_tipo_utils';

export const useSuajeTipoStore = defineStore('suajeTipoStore', {
  state: () => ({
    entity: 'suaje-tipo',
    suajeTipos: [],
    page: 1,
    filters: {},
  }),
  actions: {
    async findAllSuajeTipoHTTP(params) {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, ...this.filters, ...params })}`,
      );
      if (result && result.data) {
        this.suajeTipos.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.suajeTipos = [];
    },
    setFilters(filters) {
      this.filters = filters;
    },
    resetFilters() {
      this.filters = {};
    },
  },
});
